import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback } from 'types';
import { State } from './types';

export const fetchSituationCategory = createAction('situationCategory/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedSituationCategory = createAction(
  'situationCategory/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchSituationCategory,
  fetchedSituationCategory,
};
